import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { useForwardedRef } from '../../hooks/useForwardedRefs';
import { usePrevious } from '../../hooks/usePrevious';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MobileSearchBar({
  ariaLabel,
  buttonFocused,
  cancelSearch,
  inputValue,
  onClear,
  onClick,
  onSearchFocus,
  onSearchUpdate,
  focused,
  onSearchSubmit,
  placeholder,
  use
}, ref) {
  const [searchInputValue, setSearchInputValue] = useState(inputValue || '');
  const prevInputValue = usePrevious(searchInputValue);
  const searchRef = useForwardedRef(ref);
  const buttonRef = useForwardedRef(ref);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setSearchInputValue(inputValue || '');
  }, [inputValue]);
  useEffect(() => {
    if (!searchInputValue && prevInputValue) {
      onClear();
    }
  }, [searchInputValue, prevInputValue, onClear]);
  useEffect(() => {
    if (buttonFocused && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [buttonRef, buttonFocused]);
  const handleSubmitSearch = useCallback(evt => {
    evt.preventDefault();
    onSearchSubmit(searchInputValue);
    if (searchRef.current) {
      searchRef.current.blur();
    }
  }, [searchInputValue, searchRef, onSearchSubmit]);
  const focusSearchBar = useCallback(evt => {
    if (onSearchFocus) onSearchFocus(evt);
  }, [onSearchFocus]);
  if (use === 'placeholder') {
    return /*#__PURE__*/_jsx(Clickable, {
      "aria-label": ariaLabel,
      inlineSize: "100%",
      buttonRef: buttonRef,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(SearchInput, {
        inlineSize: "100%",
        clearable: false,
        placeholder: placeholder,
        tabIndex: -1,
        value: searchInputValue
      })
    });
  }
  return /*#__PURE__*/_jsx(Form, {
    action: ".",
    onSubmit: handleSubmitSearch,
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": ariaLabel,
      children: /*#__PURE__*/_jsxs(Flex, {
        children: [/*#__PURE__*/_jsx(SearchInput, {
          clearable: focused,
          inputRef: searchRef,
          onChange: event => {
            const value = event.target.value;
            setSearchInputValue(value);
            if (onSearchUpdate) {
              onSearchUpdate(value);
            }
          },
          onFocus: focusSearchBar,
          placeholder: placeholder,
          value: searchInputValue
        }), focused && /*#__PURE__*/_jsx(Flex, {
          blockSize: "40px",
          alignItems: "center",
          marginInline: "200",
          children: /*#__PURE__*/_jsx(Clickable, {
            onClick: cancelSearch,
            children: /*#__PURE__*/_jsx(Text, {
              color: "text-core-on-fill-default",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-common.search.searchBar.cancelButton"
              })
            })
          })
        })]
      })
    })
  });
}
export default /*#__PURE__*/forwardRef(MobileSearchBar);